import { jsx as l } from "react/jsx-runtime";
const e = (a) => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...a, children: /* @__PURE__ */ l(
  "path",
  {
    fill: "#8E8EA9",
    fillRule: "evenodd",
    d: "M11.76 6.801a1.435 1.435 0 0 0 .797 0l4.31 7.45a1.418 1.418 0 0 0-.401.696H7.85a1.427 1.427 0 0 0-.401-.693L11.76 6.8Zm-.63-.378.042.04-4.312 7.453a1.374 1.374 0 0 0-.056-.015v-3.802A1.42 1.42 0 0 0 7.83 8.324l3.3-1.901Zm2.396-.583a1.428 1.428 0 1 0-2.737-.002L7.494 7.736a1.431 1.431 0 0 0-2.273.268 1.425 1.425 0 0 0 .904 2.098V13.9a1.426 1.426 0 1 0 1.37 2.368l3.293 1.897a1.425 1.425 0 0 0 1.37 1.828 1.427 1.427 0 0 0 1.355-1.873l3.274-1.887a1.431 1.431 0 0 0 2.304-.236 1.419 1.419 0 0 0-.9-2.097v-3.797a1.426 1.426 0 1 0-1.371-2.365L13.526 5.84Zm-.381.622.038-.038 3.302 1.903a1.42 1.42 0 0 0 1.027 1.772V13.9l-.055.015-4.312-7.453Zm3.348 9.256-3.28 1.89a1.425 1.425 0 0 0-1.055-.465c-.404 0-.77.167-1.029.436l-3.296-1.9a1.41 1.41 0 0 0 .015-.055h8.619l.026.094Z",
    clipRule: "evenodd"
  }
) }), t = e;
export {
  t as default
};
